const MUNCHKIN_ID = '995-MTM-359';
var didInit = false;

function initMunchkin() {
	if (didInit === false) {
		didInit = true;
		window.Munchkin.init(MUNCHKIN_ID);
	}
}

const s = document.createElement('script');
s.type = 'text/javascript';
s.async = true;
s.src = '//munchkin.marketo.net/munchkin.js';
s.onreadystatechange = function () {
	if (this.readyState === 'complete' || this.readyState === 'loaded') {
		initMunchkin();
	}
};
s.onload = initMunchkin;
document.getElementsByTagName('head')[0].appendChild(s);
